/**
 * Promsie版本的setTimeout，在指定时间后resolve
 * @param duration 延时，单位:毫秒
 */
const delay = (duration: number): Promise<any> => {
    return new Promise(resolve => {
        setTimeout(resolve, duration);
    });
};

export default delay;
